import React from "react";
import appLib from "../../libs/appLib.mjs";

const G = window.glob;

const Step = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.uid = G.generateUid('Step');
		this.renderCol = this.renderCol.bind(this);
	}
	renderCol(k) {
		return (
			<td className={k}>
				{ this.props.step[k] ?? '—' }
			</td>
		);
	}
	render() {
		const s = this.props.step;
		if ( ! s && s.id ) return '';
		return (
			<>
				<tr
					key={s.id}
					id={this.uid}
					className={"Step"}
				>
					{ this.renderCol('type') }
					<td className={"depends"}>
						{ (s.depends||[]).map( d => this.props.steps.find( si => si.id === d )?.name ).join(', ') }
					</td>
					<td className={"maxtime"}>
						{ s.maxtime ? `${ s.maxtime }’`: '' }
					</td>
					<td className={"role"}>
						{ s.from ?  s.from.map( appLib.nameByRole ).join(', ') : '' }
					</td>
					{ this.renderCol('name') }
					{ this.renderCol('desc') }
				</tr>
				{ s.hint && Array.isArray(s.hint) && s.hint.map( h => (
					<tr
						key={h.id}
						className={"Hint"}
					>
						<td className={"type"}>hint</td>
						<td/>
						<td className={"maxtime"}>{h.delay}’</td>
						<td/>
						<td className={"name"}>{h.name}</td>
						<td className={"desc"}>{h.desc}</td>
					</tr>
				))}
			</>
		)
	}
}

export default Step;